var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.items.length ? _c('ul', {
    staticClass: "sidebar-links"
  }, _vm._l(_vm.items, function (item, i) {
    return _c('li', {
      key: i
    }, [item.type === 'group' ? _c('SidebarGroup', {
      attrs: {
        "item": item,
        "open": i === _vm.openGroupIndex,
        "collapsable": item.collapsable || item.collapsible,
        "depth": _vm.depth
      },
      on: {
        "toggle": function ($event) {
          return _vm.toggleGroup(i);
        }
      }
    }) : _c('SidebarLink', {
      attrs: {
        "sidebarDepth": _vm.sidebarDepth,
        "item": item
      }
    })], 1);
  }), 0) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };